import React, {useEffect, useRef} from 'react'
import ReactDOM from 'react-dom/client'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {topCategoriesStyle} from './index.style'
import SliderInitiator from '../../../../components/slider-initiator'

const slotIDs = 'home-top-categories'

const TopCategoriesContent = () => {
    const {token} = useAccessToken()
    const {response, error} = useCustomFetch(token, slotIDs, true)
    const boxRef = useRef(null)

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '66px',
        autoplay: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    centerPadding: '30px'
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    centerPadding: '60px'
                }
            },
            {
                breakpoint: 575,
                settings: {
                    arrows: false,
                    slidesToShow: 1
                }
            }
        ]
    }

    useEffect(() => {
        if (boxRef.current && response) {
            const slideContainers = boxRef.current.querySelectorAll('.whats-happening-slider')

            slideContainers.forEach((container) => {
                const slideElements = container.querySelectorAll('.slide-item')
                if (slideElements.length > 1) {
                    const slidesArray = Array.from(slideElements).map((slide) => slide.outerHTML)
                    container.innerHTML = '' // Clear the static slider content

                    // Use createRoot to render the slider component into the container
                    const root = ReactDOM.createRoot(container)
                    root.render(<SliderInitiator slidesHtml={slidesArray} settings={settings} />)
                }
            })
        }
    }, [response])

    if (!response || error) return null

    return (
        <Box
            ref={boxRef}
            data-content-tracking="home_top_categories"
            sx={topCategoriesStyle}
            dangerouslySetInnerHTML={{__html: response}}
        />
    )
}

export default TopCategoriesContent
